import { render, staticRenderFns } from "./Tab.html?vue&type=template&id=eb33df5e&scoped=true&"
import script from "./Tab.js?vue&type=script&lang=js&"
export * from "./Tab.js?vue&type=script&lang=js&"
import style0 from "./Tab.scss?vue&type=style&index=0&id=eb33df5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb33df5e",
  null
  
)

export default component.exports